
  <nb-layout>
    <nb-layout-header fixed>
      <ngx-header></ngx-header>
    </nb-layout-header>

    <nb-layout-column class="home-layout">
      <app-home-content></app-home-content>
      <!-- <app-landing-page></app-landing-page> -->
    </nb-layout-column>

    <nb-layout-footer fixed class="bg-first">
      <ngx-footer class="text-center"></ngx-footer>
    </nb-layout-footer>
  </nb-layout> 

